import mapboxgl from "mapbox-gl";

//TODO: This is a workaround to handle https://github.com/visgl/react-map-gl/issues/1266. Remove this, and
// worker-loader, when the issue is resolved

// @ts-ignore
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default; // eslint-disable-line import/no-webpack-loader-syntax

export default mapboxgl;